import cx from 'classnames';
import React from 'react';

const TracsisLogo = ({ className }: { className?: string }) => {
	return (
		<svg
			className={cx('logo', className)}
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 573 120"
		>
			<path
				d="M164.45 36.85h-21.58V23h58.89v13.85h-21.48v60h-15.83zM236.91 70.4h-11.55v26.45h-15.68V23h34.54C259.61 23 269 33.1 269 46.82c0 13.07-8.2 20-16.17 21.92l16.61 28.11h-18zm5-33.87h-16.55V56.9h16.5c6.31 0 11.07-4 11.07-10.19s-4.72-10.18-11-10.18zM327.25 84.13h-33l-4.64 12.72h-17.25L300.93 23h19.7l28.43 73.84H331.9zm-28.78-13.62h24.47l-12.18-33.87zM345.21 60c0-22.7 17.16-38.2 38.75-38.2 16.83 0 26.24 8.86 31.44 18l-13.51 6.64A20.22 20.22 0 00384 35.75c-12.84 0-22.58 10.3-22.58 24.25s9.7 24.24 22.58 24.24a20 20 0 0017.89-10.74l13.47 6.5c-5.31 9.19-14.61 18.16-31.44 18.16-21.56.03-38.71-15.47-38.71-38.16zM428 74.5a32.39 32.39 0 0023.47 10c8.63 0 12.84-4.09 12.84-8.3 0-5.54-6.42-7.42-15-9.41-12.03-2.79-27.53-6.09-27.53-22.58 0-12.29 10.62-22.25 28-22.25 11.74 0 21.48 3.54 28.79 10.29l-8.75 11.51a31.51 31.51 0 00-21.14-8.08c-7.09 0-10.85 3.1-10.85 7.53 0 5 6.2 6.53 14.72 8.52 12.18 2.77 27.68 6.43 27.68 22.81 0 13.5-9.63 23.69-29.56 23.69-14.17 0-24.35-4.76-31.33-11.74zM488.81 23h15.72v73.85h-15.72zM520.27 74.5a32.39 32.39 0 0023.47 10c8.63 0 12.84-4.09 12.84-8.3 0-5.54-6.42-7.42-15-9.41C529.52 64 514 60.7 514 44.21 514 31.92 524.64 22 542 22c11.74 0 21.48 3.54 28.79 10.29l-8.75 11.51a31.51 31.51 0 00-21.14-8.08c-7.09 0-10.85 3.1-10.85 7.53 0 5 6.2 6.53 14.72 8.52 12.18 2.77 27.68 6.43 27.68 22.81 0 13.5-9.63 23.69-29.56 23.69-14.17 0-24.35-4.76-31.33-11.74z"
				fill="#141b4d"
			/>
			<path
				d="M67.78 22.43a38.22 38.22 0 0124.09 58.91l15.61 15.6A60.21 60.21 0 0067.78 0z"
				fill="#209022"
			/>
			<path
				d="M81.18 91.85a38.17 38.17 0 11-28.4-69.43V0a60.17 60.17 0 1044 107.47z"
				fill="#141b4d"
			/>
		</svg>
	);
};

export default TracsisLogo;
